import React, { useContext, useEffect, useState } from 'react';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { ErrorMessage } from 'components/Widgets/ErrorMessage';
import { useAPIData } from 'hooks/useAPIData';
import { UniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import useDataRefresh from 'hooks/useDataRefresh';
import { SkiInfo } from './components/SkiInfo';
import { getSkiReports } from 'services/weather/ski.service';
let dataCache = { skiReports: null };

export const SkiReports = ({ widget, dimensions }) => {
  const [fetching, setFetching] = useState(true);
  const [skiReports, setSkiReports] = useState([]);
  const [error, setError] = useState({ state: false, message: '' });
  const FusionData = useAPIData({
    successCallback: () => {
      setFetching(false);
    },
    errorCallback: () => {
      setError({ state: true, message: 'Error fetching data' });
      setFetching(false);
    },
    fetchingCallback: () => {
      setFetching(true);
    },
  });

  const uwf = useContext(UniqueWidgetRefreshContext);
  const ROUTE = 'getSkiReports';
  const LOCATION = Cookies.get('city') + '-' + Cookies.get('state');
  const UNIQUEKEY = LOCATION + '-' + ROUTE;

  useEffect(() => {
    const fetchData = async () => {
      try {
        FusionData.forceGet({ key: ROUTE, apiFunction: getSkiReports }).then((res) => {
          dataCache.skiReports = res.data.result;
          setSkiReports(dataCache.skiReports);

          setFetching(false);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setFetching(false);
      }
    };

    fetchData();
  }, [uwf[UNIQUEKEY]]);

  const dataRefresh = useDataRefresh();
  useEffect(() => {
    dataCache = { skiReports: null };
    setFetching(true);
  }, [dataRefresh.widgetRefresh]);
  useEffect(() => {
    (async () => {
      //get skiReports data
      if (!dataCache.skiReports) {
        FusionData.get({ key: ROUTE, apiFunction: getSkiReports })
          .then((res) => {
            dataCache.skiReports = res.data.result;
            setSkiReports(dataCache.skiReports);

            setFetching(false);
          })
          .catch((err) => {
            setError({ state: true, message: err.message });
          });
      } else {
        setSkiReports(dataCache.skiReports);
        setFetching(false);
      }
    })();
  }, [dataRefresh.widgetRefresh]);

  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  if (fetching && widget) {
    // if (true && widget) {
    return <WidgetLoadingAnimation widgetName={'SkiReport'} dimensions={dimensions} />;
  }

  if (fetching) return <WidgetLoadingAnimation />;

  if (skiReports && skiReports.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} updateIntervalMinutes={60} />
        <div className="p-3">No data found.</div>
      </div>
    );
  }

  return (
    <div className="d-flex h-100 flex-column">
      <WidgetTimeUpdate route={ROUTE} updateIntervalMinutes={60} />
      {skiReports.length && (
        <div className="my-3 d-flex flex-column h-100 p-2 overflow-y-auto overflow-x-hidden">
          <SkiInfo skiReports={skiReports} />
        </div>
      )}
    </div>
  );
};

